import { useEffect } from 'react'
import { Outlet, useLoaderData, useLocation } from 'react-router-dom'
import { useSignal } from '@preact/signals-react'

import { currentUrlFragmentSignal } from '../state/signals/userSettingsSignals.js'

// This component is wrapper around the Route outlet giving us an opportunity to check for an access token
// Once we can support login, extend this to conditionally to return <Outlet/> or <Navigate/> to the login screen
// depending on whether we have a user token

const PrivateRoute = () => {

    const location = useLocation()
    const { config, accessToken, user, permissionMasks, permissions } = useLoaderData()

    const currentBusinessEntityIdSignal = useSignal('')
    useEffect(() => {
        let print = false
        const currentPathName = location.pathname
        const match = currentPathName.match(/\/be\/(\d+)\/(\w+)/);
        currentBusinessEntityIdSignal.value = match ? match[1] : 0
        if (match) {
            const splat = location.pathname.split('/')
            let segments = []
            for (let i = 3; i < splat.length; i++) {
                segments.push(splat[i])
            }
            currentUrlFragmentSignal.value = segments.join('/')
        }
        else {
            currentUrlFragmentSignal.value = ''
        } 
        if (print) {
            console.log('currentBusinessEntityId', currentBusinessEntityIdSignal.value)
            console.log('currentUrlFragment', currentUrlFragmentSignal.value)
        }
    }, [location, currentBusinessEntityIdSignal])
    // this component just wraps our secure routes and sets context from the loader data
    // at this point the useris logged in and we have access to the user manifest, app config data and accessToken

    return (
        <Outlet context={{ config: config, accessToken: accessToken, user: user, permissionMasks: permissionMasks, permissions: permissions }} />
    )
}

export default PrivateRoute